import axios from '../common/request.js'
const head = process.env.API_ROOT

// 获取运输商信息
export function carriers () {
  const url = head + '/Carriers'
  return axios.get(url)
    .then((res) => {
      return Promise.resolve(res.data)
    })
    .catch((res) => {
      console.log(res)
    })
}

// 根据运输商代码获取运输商信息
export function carriersOne (carrierCode) {
  const url = head + `/Carriers/${carrierCode}`
  return axios.get(url)
    .then((res) => {
      return Promise.resolve(res.data)
    })
    .catch((res) => {
      console.log(res)
    })
}

// 根据轨迹组的Id查询已有的轨迹信息
export function trackingGroupId (trackingGroupId) {
  const url = head + `/logisticsTrackingGroup/${trackingGroupId}`
  return axios.get(url)
    .then((res) => {
      return Promise.resolve(res.data)
    })
    .catch((res) => {
      console.log(res)
    })
}

// 查询跟踪物流轨迹的请求命令
export function quickSearch (params) {
  const url = head + '/logisticsTrackings/search'
  return axios.post(url, params)
    .then((res) => {
      return Promise.resolve(res.data)
    })
    .catch((res) => {
      console.log(res)
    })
}

// 获取所有轨迹动作定义信息
export function trackingActions () {
  const url = head + '/commons/trackingActions'
  return axios.get(url)
    .then((res) => {
      return Promise.resolve(res.data)
    })
    .catch((res) => {
      console.log(res)
    })
}

// 获取所有轨迹状态定义信息
export function trackingStatuses () {
  const url = head + '/commons/trackingStatuses'
  return axios.get(url)
    .then((res) => {
      return Promise.resolve(res.data)
    })
    .catch((res) => {
      console.log(res)
    })
}



// WEBPACK FOOTER //
// ./src/api/getSearch.js